export const load = () => ({
	title: 'Frequently Asked Questions',
	showTitle: true,
});
